import { render } from "./search-nationwide-prompt.vue?vue&type=template&id=8b800880"
import script from "./search-nationwide-prompt.vue?vue&type=script&lang=js"
export * from "./search-nationwide-prompt.vue?vue&type=script&lang=js"

import "./search-nationwide-prompt.vue?vue&type=style&index=0&id=8b800880&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__